import $ from 'jquery';

const OPEN_CLASS = 'is-open';

/**
 * FAQ accordion.
 *
 * Only one item is open at a time: opening one closes whatever else was
 * open first. State lives on `aria-expanded` (native button semantics
 * already announce the change to assistive tech) and the collapsed panel
 * is removed from the accessibility tree with the `hidden` attribute
 * rather than just visually, so its content can't be tabbed to.
 */
class Faq {
    constructor($root) {
        if (!$root.length) return;

        this.root = $root.get(0);
        this.items = Array.from(this.root.querySelectorAll('.faq__item'));

        this.onClick = this.onClick.bind(this);
        this.root.addEventListener('click', this.onClick);
    }

    onClick(event) {
        const trigger = event.target.closest('.faq__trigger');

        if (null === trigger || false === this.root.contains(trigger)) {
            return;
        }

        this.toggle(trigger.closest('.faq__item'));
    }

    toggle(item) {
        if (null === item) {
            return;
        }

        const isOpen = item.classList.contains(OPEN_CLASS);

        this.items.forEach((other) => {
            if (other !== item) {
                this.setOpen(other, false);
            }
        });

        this.setOpen(item, false === isOpen);
    }

    setOpen(item, open) {
        const trigger = item.querySelector('.faq__trigger');
        const panel = item.querySelector('.faq__panel');

        item.classList.toggle(OPEN_CLASS, open);

        if (null !== trigger) {
            trigger.setAttribute('aria-expanded', true === open ? 'true' : 'false');
        }

        if (null !== panel) {
            panel.toggleAttribute('hidden', false === open);
        }
    }
}

$(function(){
    // Iterate so more than one FAQ block on a page each get their own instance.
    $('.faq').each(function(){
        new Faq($(this));
    });
});
